import { message } from 'antd'
import { useEffect, useMemo, useRef, useState } from 'react'
import atributeProcess from 'services/processes/atributeProcess'
import SeletorEquipe, { idsDe, useEquipe } from 'components/shared/SeletorEquipe'
import { getCollaboratorName } from 'utils/collaborators'

const semAcento = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()

// initialUsers chega em formatos diferentes:
//   [{ id, first_name, ... }] · ['id1', 'id2'] · { ResponsavelId: 'a,b', ResponsavelNome: 'A, B' } · 'a,b'
function idsIniciais(initialUsers, equipe) {
  if (Array.isArray(initialUsers)) {
    return idsDe(initialUsers.map((u) => (u && typeof u === 'object' ? (u.id || equipe.find((c) => c.email && c.email === u.email)?.id) : u)))
  }
  if (initialUsers && typeof initialUsers === 'object') {
    if (initialUsers.ResponsavelId) return idsDe(initialUsers.ResponsavelId)
    return idsDe(initialUsers.ResponsavelNome)
      .map((n) => equipe.find((c) => semAcento(getCollaboratorName(c)) === semAcento(n))?.id)
      .filter(Boolean).map(String)
  }
  return idsDe(initialUsers)
}

// Responsáveis do processo. Processo já salvo: grava na hora; novo: devolve ao formulário.
function AtributeProcess({ processId, successCallback, initialUsers = [] }) {
  const equipe = useEquipe()
  const [ids, setIds] = useState([])
  const emitido = useRef(null)

  // A tela recria initialUsers a cada renderização: compara pelo conteúdo, não pela referência
  const chaveInicial = JSON.stringify(initialUsers ?? null)
  const iniciais = useMemo(() => idsIniciais(initialUsers, equipe), [chaveInicial, equipe]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    // depois que a pessoa escolheu, o eco da própria escolha não reseta a seleção
    if (emitido.current === null) setIds(iniciais)
  }, [iniciais])

  const mudar = async (novos, pessoas) => {
    const anteriores = ids
    emitido.current = novos.join(',')
    setIds(novos)
    const names = pessoas.map(getCollaboratorName).join(', ')
    const idsJoined = pessoas.map((p) => p.id).join(',')

    if (!processId) {
      successCallback?.({ users: pessoas, ResponsavelNome: names, ResponsavelId: idsJoined })
      return
    }
    if (!pessoas.length) {
      setIds(anteriores)
      message.warning('O processo precisa de pelo menos um responsável.')
      return
    }
    try {
      await atributeProcess(processId, names, idsJoined)
      successCallback?.({ users: pessoas })
      message.success('Responsáveis atualizados.')
    } catch (err) {
      setIds(anteriores)
      message.error('Não foi possível salvar os responsáveis. Tente novamente.')
    }
  }

  return <SeletorEquipe value={ids} onChange={mudar} equipe={equipe} placeholder='Atribuir responsáveis' />
}

export default AtributeProcess
